import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Tab } from '@platform-ui/design-system';
import { ChildElement } from '../utils';
import { DSTabs } from './Tabs';
export var DSTab = /*#__PURE__*/function (_ChildElement) {
  _inherits(DSTab, _ChildElement);

  var _super = _createSuper(DSTab);

  function DSTab() {
    var _this;

    _classCallCheck(this, DSTab);

    _this = _super.call(this, Tab['__docgenInfo'].props);

    _defineProperty(_assertThisInitialized(_this), "parentName", DSTabs.name);

    _defineProperty(_assertThisInitialized(_this), "component", Tab);

    return _this;
  }

  return DSTab;
}(ChildElement);

_defineProperty(DSTab, "_props", ['key'].concat(_toConsumableArray(Object.keys(Tab['__docgenInfo'].props))));
//# sourceMappingURL=Tab.js.map